export default __webpack_public_path__ + "static/media/about.c66eea6b.png";